<template>
  <v-container fluid>
    <v-data-table
      :headers="headers"
      :items="jobListingStatuses"
      class="elevation-1"
      :loading="isLoading"
    >
      <template v-slot:top>
        <v-toolbar
          flat
        >
          <v-btn
            color="success"
            data-cy="JobListingStatus-button-new"
            @click="$router.push({
              name: 'admin-EditJobListingStatus',
            })"
          >
            <v-icon class="mr-2">
              {{ mdiPlus }}
            </v-icon>
            {{ $t('common.buttons.new') }}
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item.actions="{ item }">
        <TableBasicButtons
          :editLink="{
            name: 'admin-EditJobListingStatus',
            query: { id: item.id },
          }"
          @delete="remove(item)"
        />
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { mdiPlus } from '@mdi/js';
import TableBasicButtons from '@codehq/aurora-app-core/src/components/TableBasicButtons.vue';
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  name: 'ListJobListingStatus',
  module: 'JobListingStatuses',
  components: {
    TableBasicButtons,
  },
  mixins: [loading],
  data() {
    return {
      /**
      * Icons
      */
      mdiPlus,
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('jobListingStatuses', ['jobListingStatuses']),
    /**
    * Get table column headers
    */
    headers() {
      return [
        {
          text: this.$$t('name'),
          value: 'name',
        },
        {
          text: '',
          value: 'actions',
        },
      ];
    },
  },
  async mounted() {
    this.isLoading = true;
    await this.LOAD_jobListingStatuses();
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('jobListingStatuses', ['LOAD_jobListingStatuses', 'DELETE_jobListingStatus']),
    /** Delete JobListingStatus from the collection
     */
    async remove(jobListingStatus) {
      this.isLoading = true;
      await this.DELETE_jobListingStatus(jobListingStatus.id);
      this.isLoading = false;
    },
  },
};
</script>

<docs>
# JobListingStatus example

'''js
<JobListingStatus />
'''
</docs>
